import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SampleTrackingSelectFilterService {

    public clearSelectedFilters = new Subject<boolean>();
    public resetMyFilters = new Subject<boolean>();
    public resetAllFilters = new Subject<boolean>();

    public clearFilters$ = this.clearSelectedFilters.asObservable();

    constructor() {
    }

    public clearFilterSelection(mission: boolean) {
        this.clearSelectedFilters.next(mission);
    }

}